import React from 'react';
import NumberFormat from 'react-number-format';

interface IPhoneNumberProps {
  value: string
}

const PhoneNumber: React.FC<IPhoneNumberProps> = props =>
  <NumberFormat displayType={'text'} format="(###) ###-####" value={props.value.substr(-10)} />

export default PhoneNumber;
